/* Text input cu label, icon prefix opțional și styling brand-ul Petzy.
 * Folosit pe paginile de auth (login + register) ca să eliminăm duplicarea
 * de markup. Forward-uim toate props-urile non-vizuale către <input>.
 *
 * Două variante de render:
 *   - default (label-above): eticheta deasupra input-ului, suport icon prefix.
 *     Folosită pe Register, ProLogin, ProRegister — fluxurile cu mai multe
 *     câmpuri unde eticheta-deasupra ține pagina compactă.
 *   - floating (Airbnb-style): eticheta în interiorul input-ului, animată
 *     sus când câmpul e focused sau are conținut. Activat cu prop
 *     `floating`; ignoră icon-ul (Airbnb-pattern n-are icoane, doar copy
 *     de label) și pierde hint-ul de sub label. Folosită pe LoginPage. */
export default function TextField({
  id,
  label,
  icon: Icon,
  type = 'text',
  hint,
  required = false,
  floating = false,
  className = '',
  ...inputProps
}) {
  if (floating) {
    return (
      <div className={`relative ${className}`}>
        <input
          // Spread first so the explicit attrs that follow are the source
          // of truth for the contract this variant promises (id wires the
          // label, type drives keyboard + validation, required gates the
          // form, placeholder makes peer-placeholder-shown actually fire).
          // Matches the defensive pattern PasswordField uses for the same
          // reason. Caller's value/onChange/autoComplete/etc still come
          // through the spread untouched.
          {...inputProps}
          id={id}
          type={type}
          required={required}
          placeholder={label || ' '}
          className="peer w-full px-6 pt-5 pb-1.5 border border-neutral-200 rounded-full text-sm text-neutral-950 placeholder-transparent focus:outline-none focus:border-neutral-950 focus:ring-0 transition disabled:bg-neutral-50 disabled:text-neutral-600 disabled:cursor-not-allowed"
        />
        {label && (
          <label
            htmlFor={id}
            className="absolute left-6 top-1.5 text-[10px] font-bold text-neutral-500 uppercase tracking-wider transition-all
                       peer-placeholder-shown:text-sm peer-placeholder-shown:top-3.5 peer-placeholder-shown:font-normal peer-placeholder-shown:normal-case peer-placeholder-shown:tracking-normal
                       peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:font-bold peer-focus:uppercase peer-focus:tracking-wider peer-focus:text-neutral-600
                       peer-disabled:text-neutral-600"
          >
            {label}
          </label>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1.5">
          {label}{required && <span className="text-orange-500"> *</span>}
          {hint && <span className="ml-1 text-gray-400 font-normal">{hint}</span>}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
        )}
        <input
          id={id}
          type={type}
          required={required}
          className={`w-full ${Icon ? 'pl-10' : 'pl-6'} pr-6 py-2.5 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition bg-white text-sm placeholder:text-gray-400 disabled:bg-gray-50 disabled:text-gray-500`}
          {...inputProps}
        />
      </div>
    </div>
  );
}
